export default __webpack_public_path__ + "static/media/dice-1.b151f378.svg";